import { Link } from 'react-router-dom';
import { useState } from 'react';
import { getPackages } from '../services/assuranceService';

export default function Congratulation() {
  // const cotationResult = JSON.parse(localStorage.getItem('cotationResult') || '{}');
  const subscribeResult = JSON.parse(localStorage.getItem('subscribeResult') || '{}');
  const subscriberData = JSON.parse(localStorage.getItem('subscriberData') || '{}');
  const principalData = JSON.parse(localStorage.getItem('principalData') || '{}');
  const isPrincipal = localStorage.getItem('isPrincipal');
  const selectedPackageKey = localStorage.getItem('selectedPackage');
  const activityClass = localStorage.getItem('activityClass');
  const [selectedPackage, setSelectedPackage] = useState(null);

  // Vérifier si l'assuré principal a plus de 65 ans
  const calculateAge = (dob) => {
    if (!dob) return null;
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age--;
    return age;
  };
  const principalDob = isPrincipal === 'yes'
    ? subscriberData.date_naissance
    : principalData.date_naissance;
  const principalIsOver65 = principalDob ? (calculateAge(principalDob) || 0) > 65 : false;

  // Pas de valeur par défaut — null si le prix n'est pas trouvé
  let totalPremium = null;
  let quotation  = {};
  let subscription = {};

  // Charger les détails du package sélectionné
  const loadPackageDetails = async () => {
    try {
      const packages = await getPackages();
      const packagesList = Array.isArray(packages) ? packages : packages.data || [];
      const found = packagesList.find(pkg => pkg.key === selectedPackageKey);
      if (found) {
        setSelectedPackage(found);
      }
    } catch (err) {
      console.error('Erreur lors de la récupération des détails du package:', err);
    }
  };

  if (selectedPackageKey && !selectedPackage) {
    loadPackageDetails();
  }

  // Fonction utilitaire pour extraire le prix de différentes structures
  const extractPrice = (data) => {
    const possiblePaths = [
      // 'data.data.quotation.total_premium.value',
      // 'data.data.quotation.total_premium',
      // 'data.data.quotation.totalPremium',
      // 'data.data.quotation.price',
      // 'data.data.quotation.amount',
      // 'data.data.quotation.premium',
      'data.quotation.total_premium.value',
      'data.quotation.total_premium',
      'data.quotation.totalPremium',
      'data.quotation.price',
      'data.quotation.amount',
      'data.quotation.premium',
      // 'data.quotation',
      // 'quotation.total_premium.value',
      // 'quotation.total_premium',
      // 'quotation.totalPremium',
      // 'quotation.price',
      // 'quotation.amount',
      // 'quotation.premium',
      // 'result.data.quotation.total_premium',
      // 'result.quotation.total_premium',
      // 'response.data.quotation.total_premium',
      // 'response.quotation.total_premium'
    ];

    for (const path of possiblePaths) {
      const keys = path.split('.');
      let value = data;
      let found = true;

      for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
          value = value[key];
        } else {
          found = false;
          break;
        }
      }

      if (found && (typeof value === 'number' || (typeof value === 'string' && !isNaN(Number(value))) || (typeof value === 'object' && value && typeof value.value === 'number'))) {
        const price = typeof value === 'object' ? Number(value.value) : Number(value);
        return price;
      }
    }

    if (typeof data === 'number') return data;
    if (typeof data === 'string' && !isNaN(Number(data))) return Number(data);

    return null;
  };

  // Extraire les détails
  if (subscribeResult?.data) {
    quotation = subscribeResult.data.quotation;
    subscription = subscribeResult.data.subscription;
  } else if (subscribeResult) {
    quotation = subscription = subscribeResult;
  }

  // Extraire le prix uniquement si l'assuré n'a pas plus de 65 ans
  if (!principalIsOver65) {
    const extractedPrice = extractPrice(subscribeResult);
    const isValidPrice = (p) => typeof p === 'number' && !isNaN(p) && p > 0;
    if (isValidPrice(extractedPrice)) {
      totalPremium = extractedPrice;
    }
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('fr-FR').format(value) + ' F CFA';
  };

  return (
    <section className="py-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
        <img src="assets/images/congrat.gif" alt="Félicitations" className="mx-auto h-24" />
        <h1 className="mt-6 text-2xl font-normal text-primary uppercase">
          Félicitations<br />
          <span className="block font-normal">Votre souscription est enregistrée !</span>
        </h1>

        {/* Section Assuré Principal */}
        <div className="mt-6 mx-3 p-4 bg-blue-50 rounded-lg border-l-4 border-secondary inline-block">
          <p className="text-sm text-gray-600">Assuré Principal</p>
          <p className="text-lg font-bold text-secondary">
            {isPrincipal === 'yes'
              ? `${subscriberData.prenoms} ${subscriberData.nom}`
              : `${principalData.prenoms} ${principalData.nom}`}
          </p>
        </div>
        
        {/* Section Numero de Souscription */}
        <div className="mt-6 mx-3 p-4 bg-blue-50 rounded-lg border-l-4 border-secondary inline-block">
          <p className="text-sm text-gray-600">Numero de Souscription</p>
          <p className="text-lg font-bold text-secondary">
            {subscription.number}
          </p>
        </div>

        {/* Montant ou message selon l'âge */}
        {principalIsOver65 ? (
          <div className="mt-6 p-6 bg-amber-50 border border-amber-300 rounded-xl text-left">
            <p className="text-amber-800 text-lg font-semibold">
              Votre demande sera étudiée par le médecin conseil, car vous avez dépassé l'âge limite de souscription qui est fixé à 65 ans.
            </p>
          </div>
        ) : totalPremium !== null ? (
          <p className="mt-6">
            Votre prime à payer est de
            <span className="block text-4xl font-bold text-red-600 mt-2">{formatCurrency(totalPremium)}</span>
          </p>
        ) : null}

        {/* Tableau des détails — masqué pour les +65 ans */}
        {!principalIsOver65 && Object.keys(quotation).length > 0 && (
          <div className="mt-8">
            <h3 className="text-lg font-semibold mb-4 bg-secondary text-white p-2 rounded uppercase">Détails primes</h3>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow">
                <tbody>
                  {(() => {
                    const renderItems = (data, parentKey = '') => {
                      const rows = [];

                      const processItem = (key, item, index) => {
                        if (key === 'total_premium' || key === 'totalPremium') return;

                        const rowClass = rows.length % 2 === 0 ? 'bg-gray-50' : 'bg-white';
                        const uniqueKey = parentKey ? `${parentKey}-${key}-${index}` : `${key}-${index}`;

                        if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
                          if (item.text && (item.value !== undefined || item.amount !== undefined || item.price !== undefined)) {
                            const value = item.value ?? item.amount ?? item.price;
                            rows.push(
                              <tr key={uniqueKey} className={`${rowClass} border-b border-gray-200`}>
                                <td className="py-3 px-4 text-left bg-secondary text-white border border-black">{item.text}</td>
                                <td className="py-3 px-4 text-right font-bold border border-black">
                                  {typeof value === 'number' ? formatCurrency(value) : value}
                                </td>
                              </tr>
                            );
                          } else {
                            Object.entries(item).forEach(([subKey, subItem], subIndex) => {
                              processItem(subKey, subItem, subIndex);
                            });
                          }
                        } else if (Array.isArray(item)) {
                          item.forEach((subItem, subIndex) => {
                            processItem(`${key}-item`, subItem, subIndex);
                          });
                        } else if (typeof item === 'number') {
                          rows.push(
                            <tr key={uniqueKey} className={`${rowClass} border-b border-gray-200`}>
                              <td className="py-3 px-4 text-left bg-secondary text-white border border-black capitalize">
                                {key.replace(/_/g, ' ')}
                              </td>
                              <td className="py-3 px-4 text-right font-bold border border-black">
                                {formatCurrency(item)}
                              </td>
                            </tr>
                          );
                        } else if (typeof item === 'string' && item.trim() !== '') {
                          rows.push(
                            <tr key={uniqueKey} className={`${rowClass} border-b border-gray-200`}>
                              <td className="py-3 px-4 text-left bg-secondary text-white border border-black capitalize">
                                {key.replace(/_/g, ' ')}
                              </td>
                              <td className="py-3 px-4 text-right text-gray-700 border border-black">
                                {item}
                              </td>
                            </tr>
                          );
                        }
                      };

                      Object.entries(data).forEach(([key, item], index) => {
                        processItem(key, item, index);
                      });

                      return rows;
                    };

                    return renderItems(quotation);
                  })()}
                </tbody>
                {totalPremium !== null && (
                  <tfoot>
                    <tr className="bg-primary/30 font-bold">
                      <td className="py-3 px-4 text-left">Total à payer</td>
                      <td className="py-3 px-4 text-right text-red-600">{formatCurrency(totalPremium)}</td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        )}

        {(totalPremium > 2000000) ? (
          <div className="mt-6 p-6 bg-amber-50 border border-amber-300 rounded-xl text-center">
            <p className="text-amber-800 font-semibold mb-5">
              Merci d'avoir choisi notre assurance Santé Flex. <br/> 
              Pour le règlement de votre prime, nous vous prions de faire un chèque à l'ordre de à l’ordre de <strong>SAAR ASSURANCES CI</strong> ou 
              de contacter le service client de <strong>QUALITAS ASSURANCES</strong>.
            </p>
            <a href="/" className="rounded-full border border-secondary px-6 py-3 text-secondary transition hover:bg-secondary hover:text-light"
            >
              Retour à l'accueil
            </a>
          </div>
        ) : ((activityClass !== 5) ? (
          <div className="mt-6">
            <p className="max-w-4xl mx-auto">
              Merci d'avoir choisi notre assurance Santé Flex. <br/> 
              Votre souscription sera active dans un délai de deux (02) jours ouvrés après le paiement total de votre prime.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
              <a href="/"
                className="rounded-full border border-secondary px-6 py-3 text-secondary transition hover:bg-secondary hover:text-light"
              >
                Payer plus tard
              </a>
              {!principalIsOver65 && (
                <Link
                  to="/investment-validation"
                  className="rounded-full bg-primary px-6 py-3 text-secondary cursor-pointer transition hover:bg-primary-dark hover:text-light"
                >
                  Payer maintenant
                </Link>
              )}
            </div>
          </div>
        ) : (
          <div className="mt-6 p-6 bg-amber-50 border border-amber-300 rounded-xl text-center">
            <p className="text-amber-800 font-semibold mb-5">
              Merci d'avoir choisi notre assurance Santé Flex. <br/> 
              Votre prime exacte à payer vous sera communiquée après validation de l’équipe technique. Vous recevrez un mail de confirmation.
            </p>
            <a href="/" className="rounded-full border border-secondary px-6 py-3 text-secondary transition hover:bg-secondary hover:text-light"
            >
              Retour à l'accueil
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
